import script from "./Signlaunch.vue?vue&type=script&lang=ts&setup=true"
export * from "./Signlaunch.vue?vue&type=script&lang=ts&setup=true"

import "./Signlaunch.vue?vue&type=style&index=0&id=1373f116&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1373f116"]])

export default __exports__